import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'search-select-dropdown',
})

export default class SearchSelectDropdown extends Vue {

    @Prop()
    public listArray: any;

    @Prop()
    public selectedItemList: any;

    @Prop()
    public headerText: any;

    @Prop()
    public bindProp: any;

    public onSelectSingleClick(item: any) {
        if (item === 'none') {
            this.$emit('onSelectItem', null);
        } else {
            this.$emit('onSelectItem', item);
        }
    }

    private onSearchItemsText(value: any) {
        this.$emit('onSearchTerm', value);
    }
}
